export const CIRCLE_BASE_SIZE = 32;
export const BOX_BASE_HEIGHT = 15;
export const BOX_BASE_WIDTH = 40;